import Decimal from "./decimal";

export function flattenObject(obj, parentKey = "", result = {}) {
  for (let key in obj) {
    if (obj.hasOwnProperty(key)) {
      let newKey = parentKey ? `${parentKey}.${key}` : key;

      if (typeof obj[key] === "object" && !Array.isArray(obj[key])) {
        flattenObject(obj[key], newKey, result);
      } else {
        result[newKey] = obj[key];
      }
    }
  }

  return result;
}

export const objectToUrlParams = object => {
  const params = new URLSearchParams();

  for (const key in object) {
    if (object.hasOwnProperty(key)) {
      const value = object[key];

      if (value !== null && value !== undefined && value !== "") {
        if (Array.isArray(value)) {
          value.forEach(item => {
            params.append(key + "[]", item);
          });
        } else if (typeof value === "object") {
          for (const nestedKey in value) {
            if (value.hasOwnProperty(nestedKey)) {
              params.append(key + "[" + nestedKey + "]", value[nestedKey]);
            }
          }
        } else {
          params.append(key, value);
        }
      }
    }
  }

  return params.toString();
};

export const debounce = (func, delay) => {
  let timeoutId;

  return function() {
    clearTimeout(timeoutId);
    timeoutId = setTimeout(func, delay);
  };
};

export const throttle = (func, delay) => {
  let throttled = false;

  return (...args) => {
    if (!throttled) {
      throttled = true;
      func(...args);
      setTimeout(() => {
        throttled = false;
      }, delay);
    }
  };
};

export const getTvaRatio = year => {
  let oldTva = 0.077;
  let newTva = 0.081;

  let tvaCalculate;

  if (year < 2024) {
    tvaCalculate = oldTva;
  } else {
    tvaCalculate = newTva;
  }

  return tvaCalculate;
};

export function calculateTva({ amount, year }) {
  // since = cancelClientHowLong(prestation);
  let tvaAmount = new Decimal(0);

  // Calculate the tax amount only if isCancelInterprete is not true
  tvaAmount = new Decimal(amount).times(getTvaRatio(year));

  // Calculate the total amount including the tax
  let totalAmount = new Decimal(amount).plus(tvaAmount);

  // Convert to a number rounded to 2 decimal places
  let totalWithTvaUnrounded = Number(totalAmount.toFixed(2));

  // Calculate the remainder when divided by 0.05
  let remainder = totalWithTvaUnrounded % 0.05;

  // Determine the correction amount
  let roundCorrection;
  if (remainder < 0.025) {
    roundCorrection = -remainder; // If remainder is less than 2.5 cents, subtract the remainder
  } else {
    roundCorrection = 0.05 - remainder; // Otherwise, add the difference between 5 cents and the remainder
  }

  // Apply the correction to the total
  let totalWithTva = totalWithTvaUnrounded + roundCorrection;

  let extraCancelMessage = "";

  return {
    extraCancelAmount: 0,
    extraCancelMessage,
    roundCorrection: Number(roundCorrection.toFixed(2)),
    tvaAmount: Number(tvaAmount.toFixed(2)),
    totalWithTva: Number(totalWithTva.toFixed(2)),
  };
}

export function truncateDecimal(value, decimals) {
  // Convert to string using toFixed to ensure the number has enough decimals.
  let valueStr = value.toFixed(decimals + 1);

  // Find the position of the decimal point
  const dotIndex = valueStr.indexOf(".");
  if (dotIndex === -1) {
    // If there is no decimal point, return the value as is
    return value;
  }

  // Truncate the string to the specified number of decimal places
  valueStr = valueStr.substring(0, dotIndex + decimals + 1);

  // Convert back to number
  let truncated = Number(valueStr);

  return truncated;
}

export function removeSwissFromAdress(address) {
  // remove Suisse and Switzerland
  let clean = address
    .replace(/, Suisse/g, "")
    .replace(/, Switzerland/g, "")
    .replace(/\s+,/g, ",");

  return clean;
}
